import {FC} from "react";
import styled from "@emotion/styled";
import {useSelector} from "react-redux";
import {getFanVotePlayer} from "modules/selectors";
import {EmptyFanVotePlayer, FanVotePlayer} from "components";
import {breakpoints} from "assets/theme";
import fieldImage from "assets/images/fanVote/field.svg";
import mobileFieldImage from "assets/images/fanVote/mobileField.svg";

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	position: relative;
	min-height: 320px;
	margin: 0 20px 40px;
	background: url(${mobileFieldImage}) no-repeat center #010101;
	background-size: cover;
	border-radius: 4px;
	border: 2px solid ${({theme}) => theme.colorPalette.secondary};
	background-position-y: 20%;

	@media (min-width: ${breakpoints.tablet}) {
		background-position-y: center;
		background-image: url(${fieldImage});
		margin: 0;
	}
`;

export const FanVoteField: FC = () => {
	const player = useSelector(getFanVotePlayer);

	return <Wrapper>{player ? <FanVotePlayer player={player} /> : <EmptyFanVotePlayer />}</Wrapper>;
};
